// import "./src/styles/theme.css"
// using the material-ui theme, just import the fonts...
import "./src/fonts/stylesheet.css"

import configureAmplify from "./src/configureAmplify"
import wrapPageElement from "./src/wrapPageElement"
import wrapRootElement from "./src/wrapRootElement"

configureAmplify()

export { wrapPageElement, wrapRootElement }

export const onInitialClientRender = () => {
  const jssStyles = document.querySelector("#jss-server-side")
  if (jssStyles && jssStyles.parentElement) {
    jssStyles.parentElement.removeChild(jssStyles)
  }
}
